import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { Color } from 'ng2-charts';
import 'chartjs-plugin-labels';
@Component({
  selector: 'app-data-source',
  templateUrl: './data-source.component.html',
  styleUrls: ['./data-source.component.scss']
})
export class DataSource implements OnInit {

  @Input() dataReport: any
  report_type = "day";
  dtOptions: DataTables.Settings = {};
  title_report = "Tổng hợp nguồn dữ liệu";
  constructor() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      ordering: false,
      searching: false,
      paging: false,
      language: {
        infoEmpty: 'Không tìm thấy dữ liệu',
        infoFiltered: '(trong _MAX_ )',
        info: '',
        lengthMenu: 'Hiển thị _MENU_ ',
        search: 'Tìm kiếm',
        zeroRecords: 'Không có dữ liệu !',
        paginate: {
          first: '<<',
          previous: '<',
          next: '>',
          last: '>>',
        }
      },
      columnDefs: [
        { 'targets': [], 'searchable': false }
      ]
    };
  }
  getWidth(item, seg) {
    let neg = item["neg"];
    let neu = item["neu"];
    let pos = item["pos"];
    let width = ((item[seg] / (neg + neu + pos)) * 100).toFixed(2);
    let result = width;
    if (parseInt(width) < 100) {
      result = (parseFloat(width) - 0.01).toFixed(2);
    }
    return (result + "%");
  }
  checkWidth(item, seg) {
    let neg = item["neg"];
    let neu = item["neu"];
    let pos = item["pos"];
    let width = parseFloat(((item[seg] / (neg + neu + pos)) * 100).toFixed(2));
    if (width >= 10) {
      return true;
    }
    return false;
  }
  ngOnInit(): void {
  };
  ngOnChanges(changes: SimpleChanges) {
    console.log(this.dataReport);
    if (this.dataReport && this.dataReport["report_title"]) {
      this.title_report = this.dataReport["report_title"];
    }
    this.report_type = this.dataReport["report_type"];
  }

}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/reports-component/data-source/data-source.component.ts